module.exports = __webpack_public_path__ + "img/myhomes.061f51f1.png";